import React, { createContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { reportListData, getDownloadExcel } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";

export const VehicleDetailsContext = createContext({});
export const VehicleDetailsContextProvider = ({ children }) => {
  const [vehicleData, setVehicleData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [currentPageData, setCurrentPageData] = useState(1);
  const [toDate, setToDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [excelReport, setExcelReport] = useState("");
  const [zoneNewExcel, setZoneNewExcel] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [downloadExcelSpinnerStatus, setDownloadExcelSpinnerStatus] =
    useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [spinnerStatus ,setSpinnerStatus] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  console.log("state", location.state);

  const vehicleReportData = () => {
    const apiResponseFromData = location?.state?.filteredData;
    setSearchCategory(location?.state?.visitorType.name);
    setVehicleData(apiResponseFromData?.result?.data?.result);
    setExcelReport(apiResponseFromData?.result?.data?.excelFile);
    setFromDate(apiResponseFromData?.fromDate);
    setToDate(apiResponseFromData?.toDate);
    setPageCount(apiResponseFromData?.result?.data?.numPages);
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };
  const downloadExcelSheet = async () => {
    const data = {
      search: "report",
      filter: "visitor",
      empData: "",
      fromDate: fromDate,
      toDate: toDate,
      zoneFilter: "",
      categoryFilter: "",
      visitorType: searchCategory,
    };
    setDownloadExcelSpinnerStatus(true);

    try {
      const response = await getDownloadExcel(data);
      if (response.data.status === 200) {
        setZoneNewExcel(response?.data?.data?.filename);
        setDownloadExcelSpinnerStatus(false);
      }
    } catch (error) {
      setDownloadExcelSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const dataFiltered = async (pageNumber) => {
    const data = {
      page: pageNumber,
      filter: "visitor",
      fromDate: fromDate,
      toDate: toDate,
      category: searchCategory,
    };
  setSpinnerStatus(true)
    try {
      const response = await reportListData(data);
      setVehicleData(response?.data?.data?.result?.data?.result);
      setSpinnerStatus(false)
    } catch (error) {
      setSpinnerStatus(false)
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
       
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
      
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
       
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    vehicleReportData();
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      downloadExcelSheet();
    }
  }, [fromDate, toDate]);

  const onPageChange = (e) => {
    setCurrentPageData(e);
    dataFiltered(e);
  };

  const providerValue = {
    goBack,
    vehicleReportData,
    excelReport,
    vehicleData,
    fromDate,
    zoneNewExcel,
    toDate,
    pageCount,
    currentPageData,
    onPageChange,
    downloadExcelSpinnerStatus,
    logout,
    setShowAlert,
    showAlert,
    alertMessage,
    statusCode,
    spinnerStatus ,setSpinnerStatus
  };
  return (
    <VehicleDetailsContext.Provider value={providerValue}>
      {children}
    </VehicleDetailsContext.Provider>
  );
};
